export { BuildingIcon } from './BuildingIcon'
